import { render, staticRenderFns } from "./CompanyBranchesList.vue?vue&type=template&id=27ba3d41"
import script from "./CompanyBranchesList.vue?vue&type=script&lang=js"
export * from "./CompanyBranchesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports